"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconTable = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M25.43 20.45H.53V10.06h24.9zm-22.2-2.7h19.5v-5H3.23zM69.47 20.45H28.8V10.06h40.67zm-38-2.7h35.3v-5H31.5zM25.43 33.86H.53V23.47h24.9zm-22.2-2.7h19.5v-5H3.23zM69.47 33.86H28.8V23.47h40.67zm-38-2.7h35.3v-5H31.5zM25.43 47H.53V36.57h24.9zm-22.2-2.7h19.5v-5H3.23zM69.47 47H28.8V36.57h40.67zm-38-2.7h35.3v-5H31.5zM25.43 59.94H.53V49.55h24.9zm-22.2-2.7h19.5v-5H3.23zM69.47 59.94H28.8V49.55h40.67zm-38-2.7h35.3v-5H31.5z"
  })),
  height: undefined,
  width: undefined
});
IconTable.displayName = 'IconTable';
var _default = IconTable;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/table.js
// module id = 597
// module chunks = 0